export default __webpack_public_path__ + "static/media/cynthia-del-rio.a155b71d.jpg";